import { Heading, TabBar } from '@ksyos/design-system';
import { ActiveOrArchived } from '@common/enums/activeOrArchived';
import { getSelectedLanguage } from '@frontend/translate';

type HolterProceduresListHeaderProps = {
    activeTab: ActiveOrArchived;
    switchTab: (tab: ActiveOrArchived) => void;
};

export function HolterProceduresListHeader(props: Readonly<HolterProceduresListHeaderProps>) {
    const translate = getSelectedLanguage();

    return (
        <>
            <Heading
                mb={8}
                size="large"
            >
                {translate.holter.allEcgRecordings}
            </Heading>
            <TabBar>
                <TabBar.Button
                    isSelected={props.activeTab === ActiveOrArchived.active}
                    key="active"
                    onClick={() => props.switchTab(ActiveOrArchived.active)}
                >
                    {translate.holter.allActiveRecordings}
                </TabBar.Button>
                <TabBar.Button
                    isSelected={props.activeTab === ActiveOrArchived.archived}
                    key="archived"
                    onClick={() => props.switchTab(ActiveOrArchived.archived)}
                >
                    {translate.holter.history}
                </TabBar.Button>
            </TabBar>
        </>
    );
}
